import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get Freight
export const getFreight = createAsyncThunk("freight/getFreight", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getFreight({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all Freight
export const getAllFreight = createAsyncThunk("freight/getAllFreight", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllFreight();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("freight/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("freight/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("freight/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageFreight({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get Freight By id
export const getFreightById = createAsyncThunk("freight/getFreightById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getFreightById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create Freight
export const createFreight = createAsyncThunk("freight/createFreight", async (data, { rejectWithValue }) => {
  const { name, code, isActive } = data;
  try {
    const body = JSON.stringify({ name, code, isActive });
    const { data } = await API.createFreight(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateFreight = createAsyncThunk("freight/updateFreight", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const { name, code, isActive } = values;
  try {
    const body = JSON.stringify({ name, code, isActive });
    const { data } = await API.updateFreight(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("freight/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
